import { Skeleton, Stack } from "@mui/material"

function PageSkeleton() {
    return (
        <div>
            <Stack spacing={1} className="w-full py-10">
                <Skeleton variant="rounded" height={90} />
            </Stack>
            <Stack spacing={1} className="w-full py-10">
                <Skeleton variant="rounded" height={90} />
            </Stack>
            <Stack spacing={1} className="w-full py-10">
                <Skeleton variant="rounded" height={90} />
            </Stack>
        </div>
    )
}

export default PageSkeleton